import React, { FC } from 'react'

import { alpha, Box, useTheme } from '@mui/material'
import { Line } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

import { chartOptions } from '../chartOptions'
import { EmptyData } from '../EmptyData'
import { ReportWidgetsHeader } from '../ReportWidgetsHeader'
import { StyledWidgetWrapper } from '../StyledWidgetWrapper'
import { DurationItemType } from '../types'

import { getLocalizedDurationLabel } from './getLocalizedDurationLabel'

export const TransactionLenMoneyWidget: FC<{
  transactionsMoneyData: DurationItemType[] | undefined
  currency: string | undefined
  displayWidth: number
}> = ({ transactionsMoneyData, currency, displayWidth }) => {
  const { spacing, palette } = useTheme()
  const { t } = useTranslation()

  const chartData = {
    labels: transactionsMoneyData?.map((item) => getLocalizedDurationLabel(item.duration, t)),
    datasets: [
      {
        label: t('amount', 'Amount'),
        data: transactionsMoneyData?.map((item) => item.amount),
        backgroundColor: alpha(palette.blue[500] as string, 0.3),
        fill: true,
        borderColor: palette.blue[800],
        borderWidth: 2,
        tension: 0.5,
        pointRadius: 2,
      },
    ],
  }

  const isDataEmpty = transactionsMoneyData?.every(({ amount }) => Number(amount) === 0)

  return (
    <StyledWidgetWrapper>
      <ReportWidgetsHeader
        text={t('transactionLengthMoneyEquivalence', 'Transaction length: money equivalence')}
        explanation={t(
          'theChartRepresentsHowManyTransactionsMoneyWiseBelongToEachCategory',
          'The chart represents how many transactions money-wise belong to each category',
        )}
      />

      {isDataEmpty ? (
        <Box mt={4}>
          <EmptyData />
        </Box>
      ) : (
        <Box ml={spacing(-3)}>
          <Line
            data={chartData}
            options={chartOptions({ currency })}
            style={{ maxHeight: spacing(31) }}
            key={displayWidth}
          />
        </Box>
      )}
    </StyledWidgetWrapper>
  )
}
